import { Card, Typography, Row, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { AppstoreAddOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const GoToStore = ({ freeTierCount }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <Card
            bordered={true}
            style={{
                width: "100%",
                borderRadius: "10px",
                marginTop: "20px",
            }}>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "250px",
                    justifyContent: "space-between",
                }}>
                <div>
                    <Row>
                        <Typography.Text
                            style={{
                                fontSize: "medium",
                                fontWeight: "bold",
                                textAlign: "center",
                                width: "100%",
                            }}>
                            {t("home.go_to_store.used_free_tier")} {freeTierCount}/2
                        </Typography.Text>
                        <Typography.Text
                            style={{
                                fontSize: "small",
                                fontWeight: "lighter",
                                textAlign: "center",
                                width: "100%",
                            }}>
                            ({t("home.go_to_store.limit")})
                        </Typography.Text>
                    </Row>
                </div>
                <div>
                    <Row>
                        <Typography.Text
                            style={{ fontSize: "medium", fontWeight: "bold", textAlign: "center" }}>
                            {t("home.go_to_store.info")}
                        </Typography.Text>
                    </Row>
                </div>

                <Button
                    type="primary"
                    style={{ bottom: "0", width: "100%", fontWeight: "bold" }}
                    onClick={() => {
                        navigate("/pro/app");
                    }}>
                    {t("home.go_to_store.call_to_action")}
                    <AppstoreAddOutlined />
                </Button>
            </div>
        </Card>
    );
};
export { GoToStore };
